/**
 * @generated SignedSource<<8752b104456cc40db63c0d66b0e11335>>
 * @relayHash e457255d0330dca09a8fe6de476f84d4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0c78aa5a2cc3a60b4efa24d70362b4bc69d7aa78e86eeee24ac142722c78689d

import type { ConcreteRequest, Query } from 'relay-runtime';
export type entrypointGicModalParentIssueQuery$variables = {
  cloudId: string;
  parentIssueKey: string;
  shouldFetchParentIssue: boolean;
};
export type entrypointGicModalParentIssueQuery$data = {
  readonly jira: {
    readonly issueByKey?: {
      readonly issueId: string;
    } | null | undefined;
  } | null | undefined;
};
export type entrypointGicModalParentIssueQuery = {
  response: entrypointGicModalParentIssueQuery$data;
  variables: entrypointGicModalParentIssueQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "parentIssueKey"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "shouldFetchParentIssue"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "parentIssueKey"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "issueId"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "entrypointGicModalParentIssueQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "condition": "shouldFetchParentIssue",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": (v1/*: any*/),
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "issueByKey",
                "plural": false,
                "selections": [
                  (v2/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "entrypointGicModalParentIssueQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "condition": "shouldFetchParentIssue",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": (v1/*: any*/),
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "issueByKey",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "id"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "0c78aa5a2cc3a60b4efa24d70362b4bc69d7aa78e86eeee24ac142722c78689d",
    "metadata": {},
    "name": "entrypointGicModalParentIssueQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "ba8513d5335b969e816daddb6705bf83";

export default node;
